import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Message } from 'src/app/models/message/message.model';
import { environment } from 'src/environments/environment';
import { APIResponse, ApiService } from '../api/api.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class MessageApiService extends ApiService<Message> {
    protected override url = `${environment.apiBase}/messages`;

    getMessages(): Observable<Message[] | undefined> {
        const params = new HttpParams().set('perPage', 10000);
        return this.http.get<APIResponse<Message[]>>(this.url, { params }).pipe(map((response) => response.data));
    }
}
